module.exports = __webpack_public_path__ + "img/health-status-good.13865c14.svg";